<template>
  <div class="download-search">
    <div>
      <div class="files assetlist-wrapper" v-if="results.rows.length > 0">
        <div class="downloadbox assetlist layout-1-col" v-if="!showPreviews">
          <ul class="cla-asset-ul">
            <li v-for="file in results.rows" :key="file.id">
              <div>
                <a class="more-black search-download" :data-payload="file.url" @click="onDownload(file.url)">
                  {{ file.name }} {{ file.size }}
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="file-previews" v-if="showPreviews">
          <ul>
            <li v-for="file in results.rows" :key="file.id">
              <div :data-payload="file.url" @click="onDownload(file.url)">
                <div class="file-preview-container">
                  <div class="file-preview" :style="{ backgroundImage: 'url(' + file.thumbnailUrl + ')' }" role="img" :title="file.name"></div>
                </div>
                <div class="file-title">{{ file.name }}</div>
              </div>
            </li>
          </ul>
        </div>
        <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
      </div>
      <div class="no-items" v-if="results.rows.length == 0 && !isLoading">{{ labels.noItemsFound }}</div>
      <div class="searchrefinersbox" style="display: block;"
        v-if="results.rows.length > 0 && results.facets.length > 0">
        <h2>{{ labels.filterTitle }}</h2>
        <Facet v-for="facet in results.facets" :key="facet.name" :collapsed="isCollapsed(facet)" :label="facet.name"
          :facet-id="'downloads_' + facet.name" v-if="hiddenFacets.indexOf(facet.name) === -1">
          <FacetOption v-for="opt in facet.options" :label="opt.name" :value="facet.id + '=' + opt.id" :count="opt.count"
            :key="opt.id" :on-change="onFacetOptionChecked" :checked="isFacetOptionChecked(facet.id + '=' + opt.id)">
          </FacetOption>
        </Facet>
        <div class="result-facet show-previews">
          <ul>
            <FacetOption :label="labels.showPreviews" :on-change="onToggleShowPreviews" :checked="showPreviews">
            </FacetOption>
          </ul>
        </div>
        <div id="msdsDisclaimer" v-if="results.rows.length > 0" v-html="labels.msdsDisclaimer"></div>
      </div>
    </div>
    <div class="please-wait" v-if="isLoading">
      <img src="/images/pic_loading.gif" />
    </div>
    <div style="display:none">
      <DownloadForm ref="downloadForm"></DownloadForm>
    </div>
  </div>
</template>

<script>
import 'es6-promise/auto'
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import DownloadForm from './DownloadForm.vue'
import { SessionState } from './services/session-state.js'

export default {
  name: 'DownloadSearch',
  components: {
    Facet,
    FacetOption,
    Pager,
    DownloadForm
  },
  props: {
    resultCount: String,
    wsUrl: String
  },
  data() {
    return {
      labels: Labels,
      isLoading: false,
      currentQuery: "",
      tags: "",
      results: {
        rows: [],
        facets: []
      },
      collapsedFacets: Settings.downloads.collapsedFacets,
      selectedFacetOptions: [],
      isFirstQuery: true,
      hiddenFacets: Settings.hiddenFacets,
      showPreviews: false
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("downloads", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }
    var showPreviews = SessionState.get("downloads", "show_previews");
    this.showPreviews = (showPreviews === "1");
  },
  methods: {
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    search(filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      console.log("Searching for downloads with " + filters.query)
      oThis.isLoading = true;
      if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("downloads", "facets", null);
      }
      this.isFirstQuery = false;
      var url = Utils.constructNewQueryUrl("downloads", filters.query, oThis.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results);
        if (oThis.tags.length > 0) {
          oThis.selectTagsInFacets();
        }
        oThis.$emit("input", oThis.results.totalRows);
        Utils.applyVisualUpdates(".download-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("Downloads Search", filters.query, oThis.results.totalRows);
        }
      }).catch(function (err) {
        console.error("Error loading files: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.$emit("input", oThis.results.totalRows);
        oThis.isLoading = false;
      });

    },
    filter() {

    },
    onShowMore() {
      var oThis = this;
      console.log("Searching for more downloads with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("downloads", this.currentQuery, oThis.results, oThis.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".download-search");
        oThis.isLoading = false;
      }).catch(function (err) {
        console.error("Error loading downloads: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.isLoading = false;
      });
    },
    onFacetOptionChecked(opt) {
      if (!opt) return;
      this.selectedFacetOptions = Utils.processFacetChecked(this.selectedFacetOptions, opt);
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("downloads", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    isFacetOptionChecked(val) {
      return (this.selectedFacetOptions.indexOf(val) != -1);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id + "=" + opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      if (bMustReload) {
        this.search({ query: this.currentQuery, tags: "" }, true);
      }
    },
    onDownload(payload) {
      //this is no longer needed if it's taken over by the asset list, when now showing previews
      if (!this.showPreviews && window.cla && window.cla.component && window.cla.component.portlet && window.cla.component.portlet.downloadform) return;
      if (window.cla && window.cla.component && window.cla.component.portlet && window.cla.component.portlet.downloadform) {
        window.cla.component.portlet.downloadform.downloadPayload(payload, false);
      } else {
        var decoded = window.cla.lib.base64.decode(payload);
        var tmp = decoded.split('|');
        if (tmp.length != 2) {
          console.error("Malformed file URL");
          return;
        }
        var correctedUrl = tmp[1].replace("/sitecore/shell", "");
        window.open(correctedUrl, "_self");
        
      }
    },
    onToggleShowPreviews() {
      this.showPreviews = !this.showPreviews;
      SessionState.set("downloads", "show_previews", this.showPreviews ? "1" : "0");
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width: 100%;
  justify-content: center;
}

.download-search>div {
  display: flex;
  flex-direction: row;
}

.download-search .files {
  width: calc(100% - 330px);
}


.download-search .files .downloadbox {
  display: flex;
}

.download-search .files .downloadbox>UL {
  float: none;
  margin: 0;
  flex-grow: 1;
}

.searchrefinersbox {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  margin-left: 30px;
  margin-bottom: 40px;
}

.searchrefinersbox>H2 {
  padding-top: 2px;
  padding-bottom: 14px;
  font-family: 'Gotham SSm A', sans-serif;
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  font-style: normal;
  text-transform: uppercase;
  border-bottom: 1px solid #e4e4e4;
}

.show-previews {
  margin-top: 20px;
}

#msdsDisclaimer {
  margin-top: 20px;
}

.download-search .file-previews {
  width: 100%;
}

.download-search .file-previews ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.download-search .file-previews ul li {
  width: 30%;
  margin-bottom: 20px;
}

.download-search .file-previews ul li>div {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.download-search .file-previews ul li>div>.file-preview-container {
  width: 174px;
  height: 174px;
  background-color: #e4e4e4;
  padding: 5px;
}

.download-search .file-previews ul li>div>.file-preview-container>.file-preview {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}

.download-search .file-previews ul li>div>.file-title {
  max-width: 100%;
  text-align: center;
  word-wrap: normal;
  word-wrap: break-word;
  margin-top: 5px;
  font-family: "Gotham SSm A", Arial;
  font-size: 14px;
}

.search-download {
  max-width: 810px;
}

@media all and (min-width: 961px) and (max-width: 1280px) {
  .download-search .file-previews ul li>div>.file-preview-container {
    width: 144px;
    height: 144px;
  }

  .search-download {
    max-width: 530px;
  }

}

@media all and (min-width: 881px) and (max-width: 960px) {

  .download-search .file-previews ul li {
    width: 45%;
  }

  .download-search .file-previews ul li>div>.file-preview-container {
    width: 144px;
    height: 144px;
  }

  .search-download {
    max-width: 530px;
  }

}


@media all and (min-width: 781px) and (max-width: 880px) {

  .download-search .file-previews ul li {
    width: 45%;
  }

  .download-search .file-previews ul li>div>.file-preview-container {
    width: 144px;
    height: 144px;
  }

  .search-download {
    max-width: 380px;
  }

}


@media all and (max-width: 780px) {
  .download-search>div {
    flex-wrap: wrap-reverse;
  }

  .download-search .files {
    width: 100%;
  }

  .searchrefinersbox {
    width: 100%;
    margin-left: 0;
    max-width: 100%;
    min-width: 100%;
  }

  .search-download {
    max-width: calc(100vw - 80px);
  }
}

@media all and (min-width:481px) and (max-width: 720px) {

  .download-search .file-previews ul li {
    width: 45%;
  }

  .download-search .file-previews ul li>div>.file-preview-container {
    width: 144px;
    height: 144px;
  }

}

@media all and (max-width: 480px) {

  .download-search .file-previews ul li {
    width: 45%;
  }

  .download-search .file-previews ul li>div>.file-preview-container {
    width: 80px;
    height: 80px;
  }

}
</style>
